exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formItem__controlCol___325UO {\n  width: 100%; }\n\n.ant-select {\n  width: 100%; }\n\n.formItem__controlColMobile___2qPCd > div {\n  margin-bottom: 13px; }\n\n.formItem__controlColMobile___2qPCd:last-child > div {\n  margin-bottom: 0; }\n\n.formItem__groupRowMobile___uWgoW {\n  margin-bottom: 40px; }\n", ""]);

// exports
exports.locals = {
	"controlCol": "formItem__controlCol___325UO",
	"controlColMobile": "formItem__controlColMobile___2qPCd",
	"groupRowMobile": "formItem__groupRowMobile___uWgoW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/formItem.scss
// module id = 4614
// module chunks = 6